/**
 * React contexts for the active `Datastore`.
 *
 * Split from `datastore.tsx` so leaf hooks (`useDatastore`) can import the
 * contexts without dragging in the entire `Datastore` class — important for
 * trimming bundle size in platform-specific entry points.
 */

import React from 'react';

import type { Datastore } from './datastore';

export const DatastoreContext = React.createContext<Datastore | null>(null);

// Test-only override for whether the app is rendering in a sidebar, set by
// `SidebarContextWrapper`. The `null` default means "no override — ask the
// real environment": `useIsInSidebar` falls back to `getIsInSidebar()`, so
// it works without a Datastore mounted, e.g. during skeleton loading.
// `null` rather than `false` keeps "no override" distinct from "not in a
// sidebar", and keeps this leaf module free of a module-scope
// `platform-specific/url` call.
export const IsInSidebarContext = React.createContext<boolean | null>(null);
